module.exports = __webpack_public_path__ + "img/loading.2948b241.gif";